import React from "react";

import styles from "./DBSearchWidget.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  keyword: string;
  handleSearch: () => void;
  handleClear: () => void;
  handleChange: (value: string) => void;
  placeholder?: string;
  children?: React.ReactNode;
};

const DBSearchWidget: React.FC<Props> = (props) => {
  const {
    keyword,
    handleSearch,
    handleClear,
    handleChange,
    placeholder = "キーワードで検索",
    children = null,
  } = props;

  const handlePushEnter = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  return (
    <section className={styles["g-search"]} id="search">
      <div className={styles["g-search__form"]}>
        <form>
          <div className={styles["g-search__form-keyword"]}>
            <input
              type="text"
              placeholder={placeholder}
              value={keyword}
              onChange={(e) => handleChange(e.target.value)}
              onKeyPress={(e) => handlePushEnter(e)}
              className={styles["g-search__form-keyword__input"]}
            />
            {children}
            <button
              type="button"
              onClick={() => handleSearch()}
              className={styles["g-search__form-keyword__button"]}
            >
              <span>
                <FontAwesomeIcon icon={["fal", "search"]} />
                検索する
              </span>
            </button>
            <button
              type="button"
              onClick={() => handleClear()}
              className={styles["g-search__form-keyword__button--clear"]}
            >
              <FontAwesomeIcon icon={["fal", "redo"]} />
              条件をリセット
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default DBSearchWidget;
